import { Facet } from '../models/Facet';
import { IFile } from '../utilities/fileSystem/IFile';

/**
 * Facet which marks an item as an entry batch.
 */
export const entryBatchFacet = new Facet<{}>('entryBatch');

/**
 * Facet which provides a file system source file backing an entry item.
 */
export const sourceFileFacet = new Facet<IFile>('sourceFile');
